// extracted by mini-css-extract-plugin
module.exports = {"container":"thesis-cluster_container__ZHPcm","resultsContainer":"thesis-cluster_resultsContainer___p1cj","footnoteContainer":"thesis-cluster_footnoteContainer__jA8LJ"};